import { Chip } from "@mui/material";
import { CSSProperties, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { SetterOrUpdater, useRecoilValue, useSetRecoilState } from "recoil";

import { SelectOptionsDropdown } from "@ryde/controls";
import {
  allBookingCalendarCells,
  allRecordsSelectedBookingCalendar,
  BookingCellId,
  passengersBookingsCountSelector,
  selectedCellsBookingCalendarAtom,
  SelectionEnum,
} from "@ryde/shared";

import { BookingCalendarFirstCellStyled } from "./booking-calendar.styled";

interface ISelectHandler {
  setter: SetterOrUpdater<Set<BookingCellId>>;
  allCells: Set<BookingCellId>;
}

const selectAllHandler = ({ setter, allCells }: ISelectHandler): void => {
  setter(new Set(allCells));
};

const setCheckedHandler: Record<SelectionEnum, (args: ISelectHandler) => void> =
  {
    [SelectionEnum.All]: selectAllHandler,
    [SelectionEnum.None]: ({ setter }: ISelectHandler) => setter(new Set()),
    [SelectionEnum.Some]: selectAllHandler,
  };

interface IBookingCalendarHeadRowFirstCell {
  style: CSSProperties;
}

export const BookingCalendarHeadRowFirstCell = ({
  style,
}: IBookingCalendarHeadRowFirstCell): ReactElement => {
  const setSelectedCells = useSetRecoilState(selectedCellsBookingCalendarAtom);

  const allCells = useRecoilValue(allBookingCalendarCells);
  const selectedStateNew = useRecoilValue(allRecordsSelectedBookingCalendar);
  const passengersBookingsCount = useRecoilValue(
    passengersBookingsCountSelector,
  );
  const { t } = useTranslation();

  const onSetChecked = (value: SelectionEnum): void => {
    setCheckedHandler[value]({ setter: setSelectedCells, allCells });
  };

  return (
    <BookingCalendarFirstCellStyled style={style}>
      <SelectOptionsDropdown
        checked={selectedStateNew}
        setChecked={onSetChecked}
      />
      <span className="title">
        {t("ui.PASSENGERS")}
        <Chip size="small" label={String(passengersBookingsCount || 0)} />
      </span>
    </BookingCalendarFirstCellStyled>
  );
};
